import React from 'react';
import { Callout } from '../deck/Callout';
import { StepList } from '../deck/StepList';
import { StepSlide } from '../deck/StepSlide';
import { SecureMockup } from '../mockups/SecureMockup';
export function SecureAccountSlide() {
  return <StepSlide step={3} title="Secure your account" visual={<SecureMockup data-id="element-239" data-mp="2wcte8uu2xb2b" />} visualLabel="Keep your account secure page with the Add authenticator app button marked Click" data-id="element-238" data-mp="30cu0v2rc0skg">
      <Callout tone="warn" title="Before you start:" data-id="element-240" data-mp="28mfurspk8kjc">
        On your phone, open the App Store (iPhone) or Play Store (Android). Install the free
        app <strong data-id="element-241" data-mp="2hnds5s5httsy">Google Authenticator</strong> or <strong data-id="element-242" data-mp="2hofbejwnxmlr">Microsoft Authenticator</strong>.
      </Callout>
      <StepList items={[<>
            On the "Keep your account secure" page, click{' '}
            <strong data-id="element-244" data-mp="3t0zmrsu4gnlv">"Add authenticator app"</strong>.
          </>, <>Go to the next slide for what happens next.</>]} data-id="element-243" data-mp="2cnhwqhav3ap0" />
    </StepSlide>;
}